import React from "react";
import PropTypes from "prop-types";
import { Translate } from "react-thunk-i18nify";

import ImportIndex from "views/NumberPortingRequest/Import/ImportIndex";
import ExportIndex from "views/NumberPortingRequest/Export/ExportIndex";

import {
  TabWithRoute,
  TabRoute,
} from "components/Tab/TabWithRoute/TabWithRoute";

const NumberPortingRequestIndex = ({ match }) => {
  const { url: baseUrl } = match;

  return (
    <TabWithRoute match={match} redirectUrl="imports">
      <TabRoute
        resourceName="number-porting"
        resourcePath="imports"
        tabTitle={<Translate value="title.page.numberPortingRequest.imports" />}
        render={<ImportIndex />}
        baseUrl={baseUrl}
      />
      <TabRoute
        resourceName="number-porting"
        resourcePath="exports"
        tabTitle={<Translate value="title.page.numberPortingRequest.exports" />}
        render={<ExportIndex />}
        baseUrl={baseUrl}
      />
    </TabWithRoute>
  );
};

NumberPortingRequestIndex.defaultProps = {};

NumberPortingRequestIndex.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
};

export default NumberPortingRequestIndex;
